import React from 'react'
import Button from '@material-ui/core/Button'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import { UserInfo } from './model'
import authConfig from 'src/utils/authConfig'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import useGetAccountPermission from 'src/shared/services/getAccountPermission/hooks'
import useStyles from './useStyles'
// import { ReactComponent as AccountIcon } from 'src/assets/icon/account-icon.svg'
import MemberSrc from 'src/assets/img/Member.png'
import Document from 'src/assets/icon/document-icon.svg'
import Unlock from 'src/assets/icon/unlock-icon.svg'
import Member from 'src/assets/icon/member-icon.svg'
import Logout from 'src/assets/icon/logout-icon.svg'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AccountDropDownForFooter = (props: any) => {
  const { t } = useTranslation()
  const { data: permission } = useGetAccountPermission()
  const company_type = permission?.data.result_data.company_model
  const customer_id = permission?.data.result_data.customer_id
  const userData: string | null = window.localStorage.getItem('authenticatedUser')
  const userInfo: UserInfo | null = userData ? JSON.parse(userData) : null
  const avatarWord = userInfo?.user_name_ch.slice(0, 1)
  const classes = useStyles({ word: avatarWord })
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const history = useHistory()
  const hasAccQry = permission?.data.result_data.premissions.includes('acc:qry')

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  const modifyPassword = (event: React.MouseEvent<EventTarget>) => {
    handleClose(event)
    props.setPassOpen && props.setPassOpen(true)
  }

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (anchorRef.current !== null && prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup='true'
        disableRipple={true}
        onClick={handleToggle}
      >
        <div className={classes.account}>
          {/* <AccountIcon /> */}
          <img src={MemberSrc} alt='' />
          <span className={classes.accountText}>{t('global6')}</span>
        </div>
      </Button>
      <Popper style={{ zIndex: 2 }} open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id='menu-list-grow' onKeyDown={handleListKeyDown} className={classes.tabletAndMobileStyle}>
                  <MenuItem className={classes.account}>
                    <div className={classes.avatar}>{avatarWord}</div>
                    <div className={classes.name}>{userInfo?.user_name_ch}</div>
                  </MenuItem>
                  <MenuItem className={classes.itemSmallView} onClick={() => history.push('/pages/account-info')}>
                    <img src={Document} alt='' />
                    <span>{t('admin.info')}</span>
                  </MenuItem>
                  <MenuItem className={classes.itemSmallView} onClick={modifyPassword}>
                    <img src={Unlock} alt='' />
                    <span>{t('admin2')}</span>
                  </MenuItem>
                  {hasAccQry && (
                    <MenuItem
                      className={classes.itemSmallView}
                      onClick={() =>
                        (window.location.href = company_type === '1' ? '/account-management' : `/account-management/dealer/${customer_id}`)
                      }
                    >
                      <img src={Member} alt='' />
                      <span>{t('admin4')}</span>
                    </MenuItem>
                  )}
                  <MenuItem className={classes.itemSmallViewLast} onClick={() => authConfig.logOut()}>
                    <img src={Logout} alt='' />
                    <span>{t('admin3')}</span>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}

export default AccountDropDownForFooter
